import React from 'react'
import { BBDTag } from '@gravitate-js/excalibrr'
import { orderStates } from '../../../constants/orderManagement'

export const OrderStatusTag = ({ status }) => {
  let tag = null
  if (!status) return null
  switch (status.toLowerCase()) {
    case orderStates.COMPLETE:
    case orderStates.SENT:
      tag = (
        <BBDTag className='order-status-tag' success>
          {status}
        </BBDTag>
      )
      break
    case orderStates.INPROGRESS:
    case orderStates.ASSIGNED:
    case orderStates.ACCEPTED:
      tag = (
        <BBDTag className='order-status-tag' theme2>
          {status}
        </BBDTag>
      )
      break
    case orderStates.LOCKED:
      tag = <BBDTag className='order-status-tag'>Locked</BBDTag>
      break
    default:
      tag = <BBDTag className='order-status-tag'>{status}</BBDTag>
      break
  }

  return tag
}
